module.exports = __webpack_public_path__ + "static/img/aiAbility-img2.04bc1df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeaturesPhone/aiAbility-img2.png
// module id = e7Sf
// module chunks = 0